import type { TenantBranding, TenantIdentity } from "@nasam/kernel";
import type { TenantBrandingDto, TenantIdentityDto } from "./tenantDtos";

export function tenantBrandingFromDto(dto: TenantBrandingDto): TenantBranding {
  return {
    displayName: dto.displayName,
    ...(dto.logoUrl !== undefined ? { logoUrl: dto.logoUrl } : {}),
    ...(dto.primaryColor !== undefined
      ? { primaryColor: dto.primaryColor }
      : {}),
  };
}

export function tenantIdentityFromDto(dto: TenantIdentityDto): TenantIdentity {
  return { slug: dto.slug, nameEn: dto.nameEn, nameAr: dto.nameAr };
}
